import telegram_logo from 'assets/social/telegram_logo.svg'
import telegram_icon from 'assets/social/telegram_logo.svg'
import twitter_icon from 'assets/social/twitter_icon.svg'
import tiktok_icon from 'assets/social/tiktok_icon.svg'
import medium_icon from 'assets/social/medium_icon.svg'
import discord_icon from 'assets/social/discord_icon.svg'
import email_icon from 'assets/social/email_icon.svg'

export const social = {
  telegram_logo,
  telegram_icon,
  twitter_icon,
  tiktok_icon,
  medium_icon,
  discord_icon,
  email_icon,
}
